import styled, { css } from 'styled-components';
import { PaginateContainerProps } from './PaginateContainer';
import { ButtonFlatBulletProps } from '@/components/button/ButtonFlatBullet/ButtonFlatBullet';
import { baseFlatBulletCss } from '@/components/button/ButtonFlatBullet/ButtonFlatBullet.styles';

export const Element = styled.div<PaginateContainerProps & ButtonFlatBulletProps>`
  ${({ theme, ...props }) => {
    return css`
      position: absolute;
      text-align: center;
      transition: 0.3s opacity;
      transform: translate3d(0, 0, 0);
      z-index: 10;

      > .swiper-pagination-hidden {
        opacity: 0;
      }
      .swiper-pagination-disabled > .swiper-pagination,
      .swiper-pagination.swiper-pagination-disabled {
        display: none !important;
      }
      /*.swiper-horizontal > */
      &.swiper-pagination-bullets,
      &.swiper-pagination-bullets.swiper-pagination-horizontal,
      .swiper-pagination-custom,
      .swiper-pagination-fraction {
        bottom: var(--swiper-pagination-bottom, 8px);
        top: var(--swiper-pagination-top, auto);
        left: 0;
        width: 100%;
      }
      &.swiper-pagination-bullets-dynamic {
        overflow: hidden;
        font-size: 0;
      }
      &.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        position: relative;
        transform: scale(0.33);
      }
      &.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
        transform: scale(1);
      }
      &.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
        transform: scale(1);
      }
      &.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
        transform: scale(0.66);
      }
      &.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
        transform: scale(0.33);
      }
      &.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
        transform: scale(0.66);
      }
      &.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
        transform: scale(0.33);
      }
      .swiper-pagination-bullet {
        ${baseFlatBulletCss};
        display: inline-block;
      }
      button.swiper-pagination-bullet {
        margin: 0;
        padding: 0;
        box-shadow: none;
        -webkit-appearance: none;
        appearance: none;
      }
      &.swiper-pagination-clickable .swiper-pagination-bullet {
        cursor: pointer;
      }
      .swiper-pagination-bullet:only-child {
        display: none !important;
      }
      .swiper-pagination-bullet-active {
        display: inline-block;
      }

      /*.swiper-horizontal > */
      &.swiper-pagination-bullets .swiper-pagination-bullet,
      .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
        margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px);
      }
      /*.swiper-horizontal > */
      &.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
      .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
      }
      /*.swiper-horizontal > */
      &.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
      .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic
        .swiper-pagination-bullet {
        transition: 0.2s transform, 0.2s left;
      }
      .swiper-horizontal.swiper-rtl > &.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
      :host(.swiper-horizontal.swiper-rtl)&.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        transition: 0.2s transform, 0.2s right;
      }
      .swiper-pagination-fraction {
        color: var(--swiper-pagination-fraction-color, inherit);
      }

      .swiper-pagination-lock {
        display: none;
      }
    `;
  }};
`;
